import type { FeedHealthResponse } from './api';

export type DataHealthStatus = 'LIVE' | 'DEGRADED' | 'STALE' | 'OFFLINE';

type Feed = FeedHealthResponse['feeds'][number];

function normalized(feed: Feed | undefined): string {
  return feed?.status?.trim().toUpperCase() ?? 'UNKNOWN';
}

export function deriveDataHealthStatus(health: FeedHealthResponse | undefined): DataHealthStatus {
  if (!health) return 'OFFLINE';
  const fpl = health.feeds.find((feed) => feed.name === 'FPL Public JSON');
  const fplStatus = normalized(fpl);

  if (fplStatus === 'DOWN' || fplStatus === 'OFFLINE') return 'OFFLINE';
  if (fplStatus === 'STALE') return 'STALE';
  if (!['LIVE', 'OK', 'READY'].includes(fplStatus)) return 'DEGRADED';

  const espn = health.feeds.find((feed) => feed.name === 'ESPN LIVE EDGE');
  const espnStatus = normalized(espn);
  const espnMessage = espn?.message?.toLowerCase() ?? '';
  const espnUnavailable = espnMessage.includes('unavailable') || espnMessage.includes('fallback active');
  if (['DOWN', 'STALE', 'OFFLINE'].includes(espnStatus) || (espnStatus === 'READY' && espnUnavailable)) return 'DEGRADED';

  return 'LIVE';
}
